/// <amd-module name="Analytics/Shared/Common/AnalyticsHeaderComponent" />
import * as React from "react";
import { IVssComponentProperties } from "VSS/Platform/Layout";
import { CustomHeader, HeaderTitle, HeaderTitleArea, HeaderTitleRow, TitleSize } from "VSSUI/Header";
import { HeaderCommandBar, IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";

export interface IPipelineAnalyticsHeaderProps extends IVssComponentProperties {
    title: string;
    showCommandBar?: boolean;
    commandBarItems?: IHeaderCommandBarItem[];
}

export const AnalyticsHeaderComponent: React.StatelessComponent<IPipelineAnalyticsHeaderProps> = (
    props: IPipelineAnalyticsHeaderProps & {
        children?: React.ReactNode;
    }
): JSX.Element | null => {
    return (
        <CustomHeader className="bolt-header-with-commandbar flex-wrap">
            <HeaderTitleArea>
                <HeaderTitleRow>
                    <HeaderTitle className="text-ellipsis" titleSize={TitleSize.Large}>
                        {props.title}
                    </HeaderTitle>
                </HeaderTitleRow>
                {props.children}
            </HeaderTitleArea>
            {props.showCommandBar && <HeaderCommandBar className="analytics-command-bar" items={props.commandBarItems!} />}
        </CustomHeader>
    );
};
